/** @file Timeline toolbar: transport, frame field, Key, auto-key and the loop range chip. */
import type { Translate } from '@pose2d/i18n/types';
import { useStore } from 'zustand';
import { playhead } from '../../playback/playhead';
import { playheadStore } from '../../stores/playheadStore';
import { Button } from '../../ui-kit/Button';
import { NumberField } from '../../ui-kit/NumberField';
import type { TimelineAction } from './timelineActions';

/** The frame field follows the playhead only while stopped (no 60 fps re-renders while playing); `canKey` = an animation is open. */
export function TimelineToolbar({ actions, canKey, t }: { actions: Record<TimelineAction, () => void>; canKey: boolean; t: Translate }) {
  const playing = useStore(playheadStore, (s) => s.playing);
  const frame = useStore(playheadStore, (s) => (s.playing ? null : s.frame));
  const autoKey = useStore(playheadStore, (s) => s.autoKey);
  const loop = useStore(playheadStore, (s) => s.loop);
  return (
    <div className="timeline-toolbar" role="toolbar" aria-label={t('panels.timeline.toolbar')}>
      <Button label={t('panels.timeline.first')} onClick={actions.firstFrame} />
      <Button label={t('panels.timeline.prev')} onClick={actions.prevFrame} />
      <Button label={t(playing ? 'panels.timeline.pause' : 'panels.timeline.play')} onClick={actions.playPause} primary />
      <Button label={t('panels.timeline.next')} onClick={actions.nextFrame} />
      <Button label={t('panels.timeline.last')} onClick={actions.lastFrame} />
      <NumberField label={t('panels.timeline.frame')} value={frame ?? 0} min={0} step={1} precision={0} disabled={frame === null} onCommit={(f) => { playhead.setFrame(f); }} />
      <Button label={t('panels.timeline.key')} disabled={!canKey} onClick={actions.keyBones} />
      <label className="timeline-autokey">
        <input type="checkbox" checked={autoKey} onChange={actions.toggleAutoKey} />
        {t('panels.timeline.autoKey')}
      </label>
      {loop === null ? null : <Button label={t('panels.timeline.clearLoop', { a: loop[0], b: loop[1] })} onClick={actions.clearLoop} />}
    </div>
  );
}
